<template>
  <div>
    <b-card
      class="mb-2"
    >
      <b-row class="border-bottom mb-2">
        <b-col
          cols="10"
        >
          <h4> Workspace Objects Properties</h4>
          <p>
            Object properties are used to define the attributes of objects in the workspace. The Object properties will show up when you create a new object.
          </p>
        </b-col>
      </b-row>

      <!-- input group and input -->
      <b-row>
        <b-col>
          <b-form>
            <b-form-group>
              <b-input-group>
                <b-form-input
                  v-model="newObjectProperty"
                  placeholder="Add a new object property - press enter to add"
                  @keyup.enter="addTag(newObjectProperty)"
                />
                <b-input-group-append>
                  <b-button
                    variant="outline-primary"
                    @click="addTag(newObjectProperty)"
                  >
                    Add
                  </b-button>
                </b-input-group-append>

              </b-input-group>
            </b-form-group>
          </b-form>
        </b-col>
      </b-row>

      <!-- tag list -->
      <div
        v-if="obp.length > 0"
      >
        <ul

          class="list-unstyled d-inline-flex flex-wrap mb-0"
          aria-live="polite"
          aria-atomic="false"
          aria-relevant="additions removals"
        >
          <b-card
            v-for="property in obp"
            :key="property.id"
            tag="li"
            class="mt-1 mr-1 border border-primary"
            body-class="py-1 pr-2 text-nowrap text-truncate"
          >
            <strong>{{ property.name }}</strong>
            <b-button
              class="ml-1"
              variant="outline-danger"
              size="sm"
              @click="removeTag(property)"
            >
              Remove
            </b-button>
          </b-card>
        </ul>
      </div>
      <div
        v-else
        class="text-center text-muted my-2 py-2 border border-light rounded bg-light small"
      >
        <p class="mb-0">
          No object properties have been added yet.
        </p>
      </div>
    </b-card>
  </div>
</template>

<script>

import {
  BCard,
  BRow,
  BCol,
  BButton,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BForm,
} from 'bootstrap-vue'
import { API } from 'aws-amplify'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import * as queries from '../../graphql/queries'
import * as mutations from '../../graphql/mutations'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BFormGroup,
    BForm,
  },
  data() {
    return {
      objectProperties: [],
      obp: [],
      newObjectProperty: '',
    }
  },
  created() {
    this.listObjectProperties()
  },
  methods: {
    async listObjectProperties() {
      const workspaceId = await JSON.parse(localStorage.getItem('workspace')).id
      await API.graphql({
        query: queries.getWorkspace,
        variables: {
          id: workspaceId,
        },
      }).then(res => {
        this.obp = res.data.getWorkspace.objectProperties.items
      })
    },
    async addTag(property) {
      // ask the user with a modal if they are sure they want to delete the property
      this.$bvModal.msgBoxConfirm(`Please confirm that you want to add the property ${property}`, {
        title: 'Confirm Add',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitle: 'ADD',
        cancelTitle: 'CANCEL',
        cancelVariant: 'outline-primary',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
      }).then(value => {
        if (value) {
          this.createObjectProperty(property)
        }
      })
    },
    async createObjectProperty(property) {
      const workspaceId = JSON.parse(localStorage.getItem('workspace')).id
      const roles = ['admin', 'editor', 'viewer']
      const workspaceGroups = []
      roles.forEach(role => {
        workspaceGroups.push(`${workspaceId}.${role}`)
      })
      await API.graphql({
        query: mutations.createObjectProperty,
        variables: {
          input: {
            name: property,
            workspaceObjectPropertiesId: workspaceId,
            workspaceGroups,
          },
        },
      }).then(res => {
        if (res.errors) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error Creating Object Property',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Object Property Created',
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          this.listObjectProperties()
        }
      })
    },
    async removeTag(property) {
      // ask the user with a modal if they are sure they want to delete the property
      this.$bvModal.msgBoxConfirm(`Please confirm that you want to delete the property ${property.name}`, {
        title: 'Confirm Delete',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'DELETE',
        cancelTitle: 'CANCEL',
        cancelVariant: 'outline-primary',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
      }).then(value => {
        if (value) {
          this.deleteObjectProperty(property)
        }
      })
    },
    async deleteObjectProperty(property) {
      await API.graphql({
        query: mutations.deleteObjectProperty,
        variables: {
          input: {
            id: property.id,
          },
        },
      }).then(res => {
        if (res.errors) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error Deleting Object Property',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Object Property Deleted',
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          this.listObjectProperties()
        }
      })
    },
  },
}
</script>

<style>

</style>
